import React from "react";

import { OnlineLink } from "components";
import { getFullName } from "helpers";
import { PartnerTypes, CompanyStatusTypes } from "types";

import styles from "../search.module.scss";

export const agentResultItem = (obj): { [key: string]: any } => {
	return (
		<div className={styles.wrappSearchInfo}>
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Name:</p>
					<p className={styles.content}>
						<OnlineLink
							to={`/system-setup/agent-setup/edit-agent/${obj.id}/general-info`}
							target="_blank"
						>
							{getFullName(obj)}
						</OnlineLink>
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Agent Office:</p>
					<p className={styles.content}>
						<OnlineLink
							to={`/system-setup/agent-office-setup/edit-agent-office/${obj.agentOfficeId}/general-info`}
							target="_blank"
						>
							{obj.agentOffice}
						</OnlineLink>
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Partner Type:</p>
					<p className={styles.content}>
						{PartnerTypes.getDisplayName(obj.partnerType)}
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Agent / Partner Status:</p>
					<p className={styles.content}>
						{CompanyStatusTypes.getDisplayName(obj.statusType)}
					</p>
				</div>
			}
		</div>
	);
};
